import { render, staticRenderFns } from "./ProgressWidget.vue?vue&type=template&id=2719f493"
import script from "./ProgressWidget.vue?vue&type=script&lang=js"
export * from "./ProgressWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports